import React from 'react';
import { Calendar, MapPin, ChevronRight } from 'lucide-react';

const EventCard = ({ date, title, location, description, onDetails, alternate = false }) => {
  const bgColor = alternate ? 'bg-gray-50/50' : 'bg-white';
  const borderColor = alternate ? 'border-gray-100' : 'border-gray-100';

  // Função para formatar a data corretamente
  const formatDate = (dateString) => {
    if (!dateString) return { day: '--', month: '' };
    
    // Se a data já estiver no formato "15 Mar" ou similar
    const parts = dateString.split(' ');
    if (parts.length === 2) {
      return { day: parts[0], month: parts[1] };
    }
    
    // Se for uma data completa
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return { day: '--', month: '' };
      
      const day = date.getDate();
      const month = date.toLocaleDateString('pt-PT', { month: 'short' });
      return { day: day.toString(), month };
    } catch (e) {
      return { day: '--', month: '' };
    }
  };

  const { day, month } = formatDate(date);

  return (
    <div className={`${bgColor} border ${borderColor} rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden group`}>
      <div className="p-5 flex flex-col sm:flex-row gap-5">
        {/* Date Section */}
        <div className="flex-shrink-0">
          <div className="w-20 h-20 rounded-2xl bg-emerald-50 flex flex-col items-center justify-center group-hover:bg-emerald-100 transition-colors">
            <span className="text-xl font-bold text-emerald-600 leading-tight">
              {day}
            </span>
            <span className="text-xs text-gray-500 capitalize leading-tight">
              {month}
            </span>
          </div>
        </div>

        {/* Content Section */}
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-medium text-gray-800 mb-2 group-hover:text-emerald-600 transition-colors break-words">
            {title}
          </h3>
          
          {location && (
            <div className="flex items-center gap-1.5 text-sm text-gray-500 mb-3">
              <MapPin className="w-4 h-4 text-gray-400 flex-shrink-0" />
              <span className="truncate">{location}</span>
            </div>
          )}
          
          <p className="text-gray-500 text-sm leading-relaxed mb-4 line-clamp-3 break-words">
            {description}
          </p>
          
          <button 
            onClick={onDetails}
            className="inline-flex items-center gap-2 text-emerald-600 hover:text-emerald-700 font-medium text-sm transition-colors group/btn"
          >
            Ver Detalhes
            <ChevronRight className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default EventCard;